import { mutatorAction } from 'satcheljs';
import searchDiagnosticsStore from '../store/store';

export default mutatorAction(
    'selectedDiagnosticsPanelEntryIndex',
    function selectedDiagnosticsPanelEntryIndex(index: number) {
        searchDiagnosticsStore.selectedDiagnosticsPanelEntryIndex = index;
    }
);
